import pdf from './M001 - Proof of Completion.pdf';
import pdf1 from './M320_proof_of_completion.jpg';
import './App.css';

function App() {
  return (
    <div className="container">
      <div className='sidebar'>
        <h3 className='sidebar-heading'>
          Welcome
        </h3>
        <ul className='list'>
          <li className='list-item'>
            Certificates
          </li>
        </ul>
      </div>
      <div className='main-content'>
        <div className='main-content-heading'>
          MERN Stack Developer
        </div>
        <div className='main-content-body'>
          <div className='card'>
            <div className='card-header'>
              Basic MongoDb Course
            </div>
            <div className='card-body'>
              A basic introductory course to MongoDb.
              <br />
              <br />
              <a href={pdf} target="_blank" className='link' rel='noreferrer'>View Here</a>
            </div>
          </div>
          <div className='card'>
            <div className='card-header'>
              Data Modelling
            </div>
            <div className='card-body'>
              Schema design, Relationship and pattern.
              <br />
              <br />
              <a href={pdf1} target="_blank" className='link' rel='noreferrer'>View Here</a>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
}

export default App;
